import { WhatsAppMessageTemplate } from "@/hooks/useWhatsAppMessageTemplates";

/**
 * Extracts variable placeholders ({{1}}, {{2}}, etc.) from template text fields.
 * Returns an array like ["variable_1", "variable_2"] matching the detected placeholders.
 */
export function extractVariablesFromText(template: Pick<WhatsAppMessageTemplate, 'body_text' | 'header_text'>): string[] {
  const text = `${template.header_text || ''} ${template.body_text || ''}`;
  const matches = text.match(/\{\{\s*(\d+)\s*\}\}/g);
  if (!matches) return [];

  const nums = [...new Set(matches.map(m => parseInt(m.replace(/[{}\s]/g, ''), 10)))].sort((a, b) => a - b);
  return nums.map(n => `variable_${n}`);
}

/**
 * Returns effective variables for a template:
 * - Uses template.variables if non-empty
 * - Falls back to auto-detection from body_text/header_text
 */
export function getEffectiveVariables(template: Pick<WhatsAppMessageTemplate, 'variables' | 'body_text' | 'header_text'>): string[] {
  if (template.variables && template.variables.length > 0) {
    return template.variables;
  }
  return extractVariablesFromText(template);
}
